// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"70":"987b7b0a5d0947462d3a","460":"2e9b503d95d81d4b8c4c","665":"a73fdf2b3994a124ca79"}[chunkId] + ".js";
};